<template>

    <Toast/>

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 10px;"></div>

                    <div v-if="this.company.logo != null" class="field">
                        <img :src="imageSrc" alt="Logo" class="form-logo" />
                    </div>

                    <h2>Make Booking for {{ this.companyName }}</h2>

                    <div class="field">
                        <label for="location">Location</label>
                        <Dropdown v-model="booking.location" :options="this.locations"
                                  optionLabel="name" optionValue="id"
                                  placeholder="Select a Location"/>
                    </div>

                    <div class="field">
                        <label for="practitioner">Practitioner</label>
                        <Dropdown
                            v-model="booking.practitioner"
                            :options="filteredPractitioners"
                            optionLabel="name"
                            optionValue="id"
                            placeholder="Select a Practitioner"
                            :disabled="!booking.location"
                        />
                    </div>

                    <div class="field">
                        <label for="billingPlan">Billing Plan</label>
                        <Dropdown
                            v-model="booking.billingPlan"
                            :options="filteredBillingPlans"
                            optionLabel="name"
                            optionValue="id"
                            placeholder="Select a Billing Plan"
                            :disabled="!booking.location || !booking.practitioner"/>
                    </div>

                    <div class="field">
                        <label for="timeSlot">Available Time Slots</label>

                        <Dropdown
                            v-model="booking.timeSlot"
                            :options="availableSlotOptions"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select a time slot"
                            :disabled="!booking.location || !booking.billingPlan || loadingSlots"
                            :loading="loadingSlots"
                            class="w-full"
                        />
                    </div>

                    <div style="height: 20px;"></div>

                    <h3 v-if="booking.timeSlot">Finalise Booking</h3>

                    <div class="field" v-if="booking.timeSlot">
                        <label for="existingClient">Have You Visited the Practice Before?</label>
                        <Dropdown v-model="booking.existingClient" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div style="height: 20px;"></div>

                    <h3 v-if="booking.timeSlot">Your Information</h3>

                    <div class="field" v-if="booking.timeSlot">
                        <label for="type">Type</label>
                        <Dropdown v-model="booking.type" :options="clientTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div v-if="booking.timeSlot && (booking.type === 'J')" class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="booking.name" required="true"/>
                    </div>

                    <div v-if="booking.timeSlot && (booking.type === 'N')" class="field">
                        <label for="firstName">First Name</label>
                        <InputText id="firstName" v-model.trim="booking.firstName" required="true"/>
                    </div>

                    <div v-if="booking.timeSlot && (booking.type === 'N')" class="field">
                        <label for="lastName">Last Name</label>
                        <InputText id="lastName" v-model.trim="booking.lastName" required="true"/>
                    </div>

                    <div v-if="booking.timeSlot && (booking.type === 'N')" class="field">
                        <label for="preferredName">Preferred Name</label>
                        <InputText id="preferredName" v-model.trim="booking.preferredName" required="true"/>
                    </div>

                    <div v-if="booking.timeSlot" class="field">
                        <label for="email">Email</label>
                        <InputText id="email" v-model.trim="booking.email" required="true"/>
                    </div>

                    <div v-if="booking.timeSlot" class="field">
                        <label for="mobile">Mobile Number</label>
                        <InputText id="mobile" v-model.trim="booking.mobile" required="true"/>
                    </div>

                    <div v-if="booking.timeSlot && booking.existingClient === 'N'" class="field">
                        <label for="idNumber">ID Number</label>
                        <InputText id="idNumber" v-model.trim="booking.idNumber" required="false"/>
                    </div>

                    <div v-if="booking.timeSlot && booking.existingClient === 'N'" class="field">
                        <label for="dob">Date of Birth</label>
                        <Calendar id="dob" v-model="booking.dob" dateFormat="yy-mm-dd"/>
                    </div>

                    <div v-if="booking.timeSlot && (booking.existingClient === 'N') && (booking.type === 'N')"
                         class="field">
                        <label for="gender">Gender</label>
                        <Dropdown v-model="booking.gender" :options="genderTypes" optionLabel="name" required="true"
                                  optionValue="code" placeholder="Select a Gender"/>
                    </div>

                    <div v-if="booking.timeSlot && (booking.existingClient === 'N')
                    && (booking.type === 'N') && (booking.gender === 'O')" class="field">
                        <label for="genderOther">Please Specify Gender Type</label>
                        <InputText id="genderOther" v-model.trim="booking.genderOther" required="true"/>
                    </div>

                    <div v-if="booking.timeSlot && booking.existingClient === 'N'" class="field">
                        <label for="commStatus">Communication Approval?</label>
                        <Dropdown v-model="booking.commStatus" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-if="booking.timeSlot && booking.existingClient === 'N'" class="field">
                        <label for="taxRegistered">Tax Registered?</label>
                        <Dropdown v-model="booking.taxRegistered" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-if="booking.timeSlot && (booking.existingClient === 'N')
                    && (booking.taxRegistered === 'Y')" class="field">
                        <label for="taxNumber">Tax Number</label>
                        <InputText id="taxNumber" v-model.trim="booking.taxNumber" required="false"/>
                    </div>

                    <div v-if="booking.timeSlot && booking.existingClient === 'N'" class="field">
                        <label for="addressCountry">Country</label>
                        <Dropdown v-model="booking.addressCountry" :options="countries" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-if="booking.timeSlot && booking.existingClient === 'N'" class="field">
                        <label for="address1">Address Line 1</label>
                        <InputText id="address1" v-model.trim="booking.address1" required="true"/>
                    </div>

                    <div v-if="booking.timeSlot && booking.existingClient === 'N'" class="field">
                        <label for="address2">Address Line 2</label>
                        <InputText id="address2" v-model.trim="booking.address2" required="true"/>
                    </div>

                    <div v-if="booking.timeSlot && booking.existingClient === 'N'" class="field">
                        <label for="addressRegion">Region</label>
                        <InputText id="addressRegion" v-model.trim="booking.addressRegion" required="true"/>
                    </div>

                    <div v-if="booking.timeSlot && (booking.existingClient === 'N')
                    && (booking.addressCountry === 'ZA')" class="field">
                        <label for="addressState">Province</label>
                        <Dropdown v-model="booking.addressState" :options="regionsSouthAfrica" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-if="booking.timeSlot && (booking.existingClient === 'N')
                    && (booking.addressCountry === 'UK')" class="field">
                        <label for="addressState">County</label>
                        <InputText id="addressState" v-model.trim="booking.addressState" required="true"/>
                    </div>

                    <div v-if="booking.timeSlot && (booking.existingClient === 'N')
                    && (booking.addressCountry != 'ZA') && (booking.addressCountry != 'UK')" class="field">
                        <label for="addressState">State</label>
                        <InputText id="addressState" v-model.trim="booking.addressState" required="true"/>
                    </div>

                    <div v-if="booking.timeSlot && booking.existingClient === 'N'" class="field">
                        <label for="addressPostalCode">Postal Code</label>
                        <InputText id="addressPostalCode" v-model.trim="booking.addressPostalCode" required="true"/>
                    </div>

                    <div style="height: 20px;"></div>

                    <div v-if="booking.timeSlot" class="field">
                        <span>
                        Note: This booking will be sent for approval. Once approved, you will receive confirmation of the booking.
                            The booking is not scheduled until you receive this confirmation.
                        </span>
                    </div>

                    <Button label="Create Booking" class="mr-2 mb-2"
                            :loading="submitted" :disabled="!canCreateBooking"
                            @click="createBooking"></Button>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import UserService from "@/service/UserService";
import AvailabilityService from "@/service/AvailabilityService";
import moment from 'moment';
import ClientService from "@/service/ClientService";
import CompanyService from "@/service/CompanyService";

export default {
    components: {
        IsoEvolveFooter
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[DigitalBooking][mounted] System is active.");
            console.log("[DigitalBooking][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[DigitalBooking][mounted] System is NOT active.");
            console.log("[DigitalBooking][mounted] Error = ", e);
            this.$router.push("digitalbooking");
            return;
        }

        this.companyReference = this.$route.query.company;

        console.log("[DigitalBooking][mounted] companyReference = ", this.companyReference);

        try {
            const [availabilityData, companyData] = await Promise.all([
                AvailabilityService.getCompanyAvailability(this.companyReference),
                CompanyService.getCompany(this.companyReference)
            ]);

            this.availability = availabilityData.data;
            this.company = companyData.data;

            this.processImageSrc();

            if (this.availability.length > 0) {
                this.companyName = this.availability[0].companyName;
            }

            this.locations = Array.from(
                new Map(
                    this.availability
                        .filter(a => a.locationId && a.locationName)
                        .map(a => [a.locationId, {
                            id: a.locationId,
                            name: a.locationName
                        }])
                ).values()
            );

            if (this.locations.length === 1) {
                this.booking.location = this.availability[0].locationId;
            }

            this.practitioners = Array.from(
                new Map(
                    this.availability
                        .filter(a => a.practitionerId && a.practitionerName)
                        .map(a => [a.practitionerId, {
                            id: a.practitionerId,
                            name: a.practitionerName
                        }])
                ).values()
            );

            if (this.practitioners.length === 1) {
                this.booking.practitioner = this.availability[0].practitionerId;
            }

            this.billingPlans = Array.from(
                new Map(
                    this.availability
                        .filter(a => a.billingPlanId && a.billingPlanName)
                        .map(a => [a.billingPlanId, {
                            id: a.billingPlanId,
                            name: a.billingPlanName
                        }])
                ).values()
            );

            if (this.billingPlans.length === 1) {
                this.booking.billingPlan = this.availability[0].billingPlanId;
            }

            console.log("[DigitalBooking][mounted] this.availability = ", this.availability);
            console.log("[DigitalBooking][mounted] this.locations = ", this.locations);
            console.log("[DigitalBooking][mounted] this.practitioners = ", this.practitioners);
            console.log("[DigitalBooking][mounted] this.billingPlans = ", this.billingPlans);

            this.booking.type = 'N';
            this.booking.taxRegistered = 'N';

            this.loading = false;

        } catch (e) {
            console.error("[DigitalBooking][mounted] Error fetching additional data = ", e);
        }
    },
    data() {

        return {
            profile: {},
            company: {},
            submitted: false,
            companyReference: null,
            companyName: null,
            imageSrc: '',
            errorMessage: '',
            booking: {
                location: null,
                practitioner: null,
                billingPlan: null,
                timeSlot: null
            },
            availableSlotOptions: [],
            loadingSlots: false,
            availability: [],
            locations: [],
            practitioner: [],
            billingPlans: [],
            activeTab: 1,
            optionTypes: [
                {name: 'True', code: 'True'},
                {name: 'False', code: 'False'}
            ],
            statusTypes: [
                {name: 'Active', code: 'A'},
                {name: 'Inactive', code: 'I'},
                {name: 'Pending', code: 'P'}
            ],
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            clientTypes: [
                {name: 'Natural Person', code: 'N'},
                {name: 'Juristic Person', code: 'J'},
            ],
            genderTypes: [
                {name: 'Male', code: 'M'},
                {name: 'Female', code: 'F'},
                {name: 'Other', code: 'O'}
            ],
            countries: [
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'Canada', code: 'CA'},
                {name: 'India', code: 'IN'},
                {name: 'United States', code: 'US'},
                {name: 'Namibia', code: 'NA'},
                {name: 'Australia', code: 'AU'},
                {name: 'New Zealand', code: 'NZ'},
                {name: 'Brazil', code: 'BR'},
                {name: 'China', code: 'CN'},
                {name: 'Egypt', code: 'EG'},
                {name: 'France', code: 'FR'},
                {name: 'Germany', code: 'DE'},
                {name: 'Japan', code: 'JP'},
                {name: 'Spain', code: 'ES'},
                {name: 'Slovenia', code: 'SV'},
                {name: 'Taiwan', code: 'TW'},
                {name: 'Other', code: 'OT'}
            ],
            regionsSouthAfrica: [
                {name: 'Gauteng', code: 'Gauteng'},
                {name: 'Western Cape', code: 'Western Cape'},
                {name: 'Kwa-Zulu Natal', code: 'Kwa-Zulu Natal'},
                {name: 'North-West', code: 'North-West'},
                {name: 'Free State', code: 'Free State'},
                {name: 'Eastern Cape', code: 'Eastern Cape'},
                {name: 'Mpumalanga', code: 'Mpumalanga'},
                {name: 'Northern Cape', code: 'Northern Cape'},
                {name: 'Limpopo', code: 'Limpopo'}
            ],
        }
    },
    watch: {
        'booking.location'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.booking.practitioner = null;
                this.booking.billingPlan = null;
                this.booking.timeSlot = null;
                this.availableSlotOptions = [];
            }

            this.fetchBookingAvailability();
        },

        'booking.practitioner'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.booking.timeSlot = null;
                this.availableSlotOptions = [];
            }

            this.fetchBookingAvailability();
        },

        'booking.billingPlan'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.booking.timeSlot = null;
                this.availableSlotOptions = [];
            }

            this.fetchBookingAvailability();
        }
    },
    computed: {
        canCreateBooking() {
            if ((this.booking.location) && (this.booking.practitioner) && (this.booking.billingPlan)
                && (this.booking.timeSlot) && (this.booking.existingClient) && (this.booking.type)
                && (((this.booking.type === 'J') && (this.booking.name)) ||
                    ((this.booking.type === 'N') && (this.booking.firstName) && (this.booking.lastName)))
                && (this.booking.email) && (this.booking.mobile)) {
                return true;
            } else {
                return false;
            }
        },
        filteredPractitioners() {
            if (!this.booking.location) {
                return [];
            }

            return Array.from(
                new Map(
                    this.availability
                        .filter(a =>
                            a.locationId === this.booking.location &&
                            a.practitionerId &&
                            a.practitionerName
                        )
                        .map(a => [
                            a.practitionerId,
                            {
                                id: a.practitionerId,
                                name: a.practitionerName
                            }
                        ])
                ).values()
            );
        },
        filteredBillingPlans() {
            if (!this.booking.location || !this.booking.practitioner) {
                return [];
            }

            return Array.from(
                new Map(
                    this.availability
                        .filter(a =>
                            a.locationId === this.booking.location &&
                            a.practitionerId === this.booking.practitioner &&
                            a.billingPlanId &&
                            a.billingPlanName
                        )
                        .map(a => [
                            a.billingPlanId,
                            {
                                id: a.billingPlanId,
                                name: a.billingPlanName
                            }
                        ])
                ).values()
            );
        },
    },
    methods: {
        processImageSrc() {
            if (this.company.logo != null) {
                const match = this.company.logo.match(/<img\s+[^>]*src="([^"]+)"/);
                if (match && match[1]) {
                    this.imageSrc = match[1]; // Valid base64 data URL
                    this.errorMessage = ''; // Clear any previous error messages
                } else {
                    this.imageSrc = ''; // Default or empty value
                    this.errorMessage = 'Invalid image data'; // Set an appropriate error message
                }
            }
        },
        getDayOfWeek(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString(undefined, { weekday: 'short' });
            // use 'long' if you want: Monday instead of Mon
        },
        async fetchBookingAvailability() {

            this.booking.timeSlot = null;
            this.availableSlotOptions = [];

            if (!this.booking.location || !this.booking.billingPlan) {
                return;
            }

            this.loadingSlots = true;

            try {
                const response = await AvailabilityService.getBookingAvailability(
                    this.companyReference,
                    this.booking.location,
                    this.booking.practitioner,
                    this.booking.billingPlan
                );

                this.availableSlotOptions = response.data.map(slot => ({
                    label: `${this.getDayOfWeek(slot.date)} · ${slot.date} · ${slot.startTime} – ${slot.endTime}`,
                    value: slot
                }));

                console.log("[DigitalBooking][createBooking] this.availableSlotOptions = ", this.availableSlotOptions);

            } catch (e) {
                console.error('[DigitalBooking][fetchBookingAvailability] Failed to fetch availability', e);
            } finally {
                this.loadingSlots = false;
            }
        },
        async createBooking() {
            console.log("[DigitalBooking][createBooking] this.booking = ", this.booking);

            this.submitted = true;

            try {
                var bookingDto = {
                    locationId: this.booking.location,
                    practitionerId: this.booking.practitioner,
                    billingPlanId: this.booking.billingPlan,
                    existingClient: this.booking.existingClient,
                    type: this.booking.type,
                    name: this.booking.name,
                    firstName: this.booking.firstName,
                    lastName: this.booking.lastName,
                    preferredName: this.booking.preferredName,
                    email: this.booking.email,
                    mobile: this.booking.mobile,
                    idNumber: this.booking.idNumber,
                    address1: this.booking.address1,
                    address2: this.booking.address2,
                    addressCountry: this.booking.addressCountry,
                    addressPostalCode: this.booking.addressPostalCode,
                    addressRegion: this.booking.addressRegion,
                    addressState: this.booking.addressState,
                    commStatus: this.booking.commStatus,
                    taxRegistered: this.booking.taxRegistered,
                    taxNumber: this.booking.taxNumber,
                    dob: moment(this.booking.dob)
                        .format('YYYY-MM-DD'),
                    bookingDateAndTime: moment(this.booking.timeSlot.startTimestamp)
                        .format('YYYY-MM-DD HH:mm')
                };

                console.log('[DigitalBooking][createBooking] bookingDto = ', bookingDto);

                const response = await ClientService.createClientBooking(
                    this.companyReference, bookingDto);
                console.log('[DigitalBooking][createBooking] Response = ', response);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Created booking',
                    life: 3000
                });

            } catch (error) {
                console.error('[DigitalBooking][createBooking] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to create booking. Please try again.',
                    life: 3000
                });
            }

            this.booking = {};

            if (this.locations.length === 1) {
                this.booking.location = this.availability[0].locationId;
            }

            if (this.practitioners.length === 1) {
                this.booking.practitioner = this.availability[0].practitionerId;
            }

            if (this.billingPlans.length === 1) {
                this.booking.billingPlan = this.availability[0].billingPlanId;
            }

            this.booking.type = 'N';
            this.booking.taxRegistered = 'N';

            this.activeTab = 1;
            this.submitted = false;
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}

img {
    max-width: 100%;
    height: auto;
}

.form-logo {
    width: clamp(120px, 40vw, 240px);
    height: auto;
    display: block;
    margin: 0 auto;
}
</style>
